import { createChunksMatcher } from '../createChunksMatcher';
import { createChunk } from '../Chunks';
export function withHeaders(maybeResolvableHeaders, child) {
    return createChunksMatcher(maybeResolvableHeaders, child, function (headers, request) {
        return headers ? [createChunk('headers', request, { headers: headers })] : [];
    });
}
//# sourceMappingURL=withHeaders.js.map